export const T = {
  en_GB: {
    edit: "Edit",
    description:
      "Tenant-level fee/cost classes (e.g. Normal, VIP, Mini). Each client can be assigned one; manual fees can target a specific category.",
    noCategories: 'No client cost categories configured. Click "Add Category" to create one.',
    name: "Name",
    active: "Active",
    actions: "Actions",
    categoryName: "Category name",
    save: "Save",
    cancel: "Cancel",
    add: "Add",
    addCategory: "Add Category",
    placeholder: "e.g., Normal, VIP, Mini...",
    deleteCategory: "Delete Cost Category",
    deleteDescription:
      "Are you sure you want to delete this cost category? This action cannot be undone.",
    delete: "Delete",
    error: "Error",
    failedToAdd: "Failed to add cost category",
    failedToUpdate: "Failed to update cost category",
    failedToDelete: "Failed to delete cost category",
  },
  nb_NO: {
    edit: "Rediger",
    description:
      "Avgifts-/kostnadsklasser på leietakernivå (f.eks. Normal, VIP, Mini). Hver kunde kan tildeles én; manuelle kostnader kan rettes mot en bestemt kategori.",
    noCategories: 'Ingen kundekostnadskategorier konfigurert. Klikk "Legg til kategori".',
    name: "Navn",
    active: "Aktiv",
    actions: "Handlinger",
    categoryName: "Kategorinavn",
    save: "Lagre",
    cancel: "Avbryt",
    add: "Legg til",
    addCategory: "Legg til kategori",
    placeholder: "f.eks., Normal, VIP, Mini...",
    deleteCategory: "Slett kostnadskategori",
    deleteDescription:
      "Er du sikker på at du vil slette denne kostnadskategorien? Denne handlingen kan ikke angres.",
    delete: "Slett",
    error: "Feil",
    failedToAdd: "Kunne ikke legge til kostnadskategori",
    failedToUpdate: "Kunne ikke oppdatere kostnadskategori",
    failedToDelete: "Kunne ikke slette kostnadskategori",
  },
} as const;
